export const IMAGE_LOGO = {
    en: require('./logo/logo-en.png'),
    el: require('./logo/logo-el.png')
}

